// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const stripeClient = createTypedClient();
export const createStripeClient = (config) => createTypedClient(config);
